import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { paperGoodsIssueBusiness } from "api/bussiness/paper-material/paper-goods-issue";
import { invalidatePaperCatalogCache } from "api/cached";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddPaperGoodsIssue } from "mobx-stores/_models/paper-inventory/paper-goods-issue/paper-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import {
  GetArrayItemFn,
  useGoodsIssueItemHandlers,
} from "../hooks/use-goods-issue-item-handlers";
import { useRollNumber } from "../hooks/use-roll-number";
import { getAddPaperGoodsIssueSchema } from "./schema";

export const AddPaperGoodsIssue = observer(() => {
  const queryClient = useQueryClient();
  const {
    paperInventoryManagement: {
      paperGoodsIssueStore: { openNew, getPaperGoodsIssue, setProp },
    },
  } = useStores();

  const { getRollNumberOptions, getBrandByRollNumber } = useRollNumber();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
    getArrayItemControl,
  } = useForm<IAddPaperGoodsIssue>(
    (form) => getAddPaperGoodsIssueSchema(form),
    {
      issueDate: dateTimeToUTCString(dayjs()),
      items: [
        {
          materialId: "",
          amount: 0,
          brand: "",
          rollNumber: "",
          workOrderId: "",
          workOrderPOId: "",
          woNumber: "",
          length: 0,
          sheetQuantity: 0,
          unitsPerSheet: 0,
          pcsAmount: 0,
          isTakeAll: false,
          isWaste: false,
        },
      ],
    },
  );

  const saveHandler = useCallback(
    async (data: IAddPaperGoodsIssue) => {
      try {
        await paperGoodsIssueBusiness.add(data);
        await invalidatePaperCatalogCache(queryClient);
        await getPaperGoodsIssue();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getPaperGoodsIssue, queryClient, setProp],
  );

  const { itemValueChangedHandler } = useGoodsIssueItemHandlers({
    getArrayItemControl: getArrayItemControl as unknown as GetArrayItemFn,
    getRollNumberOptions,
    getBrandByRollNumber,
  });

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm xuất kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
              onValueChanged={itemValueChangedHandler}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
